import { AfterViewInit, ChangeDetectionStrategy, Component, Renderer2, ViewEncapsulation } from '@angular/core'
import { combineLatest, empty, Observable, ReplaySubject } from 'rxjs'
import { take } from 'rxjs/operators'
import { InjectionService } from '../../../singleton-services/injection.service'
import { SegmentService } from '../../../shared/analytics/services/segment.service'
import { PlatformService } from '../../../singleton-services/platform.service'

// CXP-2265: Traditional imports don't work with this library. Doing this, since this will be deleted quickly.
declare let LiveLike: any

@Component({
  selector: 'flo-live-like',
  templateUrl: './live-like.component.html',
  styleUrls: ['./live-like.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LiveLikeComponent implements AfterViewInit {
  constructor(
    private ps: PlatformService,
    private rd: Renderer2,
    private injectionService: InjectionService,
    private segment: SegmentService
  ) {}

  private readonly ngAfterViewInit$ = new ReplaySubject<void>(1)

  ngAfterViewInit() {
    this.ngAfterViewInit$.next()
    this.ngAfterViewInit$.complete()
  }

  private getLiveLikeDeps(): Observable<readonly HTMLElement[]> {
    return this.ps.isBrowser
      ? this.injectionService.injectScripts(
          this.rd,
          ['https://unpkg.com/@livelike/engagementsdk/livelike.umd.js'],
          false
        )
      : empty()
  }

  private injectLiveLikeScripts = combineLatest([this.getLiveLikeDeps(), this.ngAfterViewInit$])
    .pipe(take(1))
    .subscribe(() => {
      LiveLike.init({
        clientId: 'Bu81PFNVktGzmyiKoJx3ITJ1hpGWVGAO9np4LuD1',
        analyticsProvider: this.segment // this connects all LiveLike events to .track() calls,
      })
    })
}
